import Default from './Default';

const AvaliacoesExperienciasDefault = Default;

export default AvaliacoesExperienciasDefault;
